"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.form.label': 'Etichetta',
    'slotData.form.value': 'Valore',
    'slotData.form.type': 'Tipo',
};
